import { Action } from "redux";
import { ApiCallModel } from "../models";
import { AppThunkAction } from ".";
import { Get } from "../api/apiUtils";
import { Reducer } from "redux";

import { PersistentDataService } from "../services/PersistentDataService";
import { WorkPacketService } from "../services/WorkPacketService";

import {
  WorkPacket,
  WorkPacketValuesModel,
  WorkPacketDocument,
  WorkPacketValue
} from "../models/TruckWorkPacket";

export interface TruckWorkPacketState {
  truckWorkPackets: ApiCallModel<WorkPacket[]>;
  truckWorkPacketDocuments: ApiCallModel<WorkPacketDocument[]>;
  truckWorkPacketValues: ApiCallModel<WorkPacketValue[]>;
}

export const defaultState = {
  truckWorkPackets: { isError: false, isLoading: false, result: [] },
  truckWorkPacketDocuments: { isError: false, isLoading: false, result: [] },
  truckWorkPacketValues: { isError: false, isLoading: false, result: [] }
} as TruckWorkPacketState;

export interface GetAllTruckWorkPackets {
  type: "GET_TRUCK_WORK_PACKETS";
  payload: ApiCallModel<WorkPacket[]>;
}

export interface GetTruckWPDocuments {
  type: "GET_TRUCK_WP_DOCUMENTS";
  payload: ApiCallModel<WorkPacketDocument[]>;
}

export interface GetTruckWPValues {
  type: "GET_TRUCK_WP_VALUES";
  payload: ApiCallModel<WorkPacketValue[]>;
}

type KnownAction =
  | GetAllTruckWorkPackets
  | GetTruckWPDocuments
  | GetTruckWPValues;

export const actionCreators = {
  getTruckAllWorkPackets: (): AppThunkAction<KnownAction> => (dispatch) => {
    dispatch({
      type: "GET_TRUCK_WORK_PACKETS",
      payload: {
        isError: false,
        isLoading: true,
        result: []
      }
    });

    dispatch({
      type: "GET_TRUCK_WORK_PACKETS",
      payload: {
        isError: true,
        isLoading: false,
        result: []
      }
    });

    Get("api/workpacket/all?modality=1")
      .then((result) => result.json())
      .then((result) => {
        PersistentDataService.saveAllWorkPacketsAsync(result as WorkPacket[]);
        dispatch({
          type: "GET_TRUCK_WORK_PACKETS",
          payload: {
            isError: false,
            isLoading: false,
            result: result
          }
        });
      })
      .catch((reason) =>
        dispatch({
          type: "GET_TRUCK_WORK_PACKETS",
          payload: {
            isError: true,
            isLoading: false,
            result: []
          }
        })
      );
  },
  getTruckWPValues:
    (
      nominationNo?: string,
      success: (() => void) | undefined = undefined
    ): AppThunkAction<KnownAction> =>
    (dispatch) => {
      dispatch({
        type: "GET_TRUCK_WP_VALUES",
        payload: {
          isError: false,
          isLoading: true,
          result: []
        }
      });
      dispatch({
        type: "GET_TRUCK_WP_DOCUMENTS",
        payload: {
          isError: false,
          isLoading: true,
          result: []
        }
      });

      dispatch({
        type: "GET_TRUCK_WP_VALUES",
        payload: {
          isError: false,
          isLoading: false,
          result: []
        }
      });

      dispatch({
        type: "GET_TRUCK_WP_DOCUMENTS",
        payload: {
          isError: false,
          isLoading: false,
          result: []
        }
      });

      // Get(`api/workpacket/${nominationNo}/values`)
      //   .then((result) => result.json())
      //   .then((result) => {
      //     PersistentDataService.saveWorkPacketValuesAsync(
      //       nominationNo,
      //       result
      //     );
      //     dispatch({
      //       type: "GET_TRUCK_WP_VALUES",
      //       payload: {
      //         isError: false,
      //         isLoading: false,
      //         result: result.values,
      //       },
      //     });

      //     dispatch({
      //       type: "GET_TRUCK_WP_DOCUMENTS",
      //       payload: {
      //         isError: false,
      //         isLoading: false,
      //         result: result.documents,
      //       },
      //     });
      //   })
      //   .catch((reason) => {
      //     dispatch({
      //       type: "GET_TRUCK_WP_VALUES",
      //       payload: {
      //         isError: true,
      //         isLoading: false,
      //         result: [],
      //       },
      //     });
      //     dispatch({
      //       type: "GET_TRUCK_WP_DOCUMENTS",
      //       payload: {
      //         isError: true,
      //         isLoading: false,
      //         result: [],
      //       },
      //     });
      //   });
    },
  setWPValues:
    (values: WorkPacketValue[]): AppThunkAction<KnownAction> =>
    (dispatch) => {
      dispatch({
        type: "GET_TRUCK_WP_VALUES",
        payload: {
          isError: false,
          isLoading: false,
          result: values
        }
      });
    },
  setWPDocuments:
    (documents: WorkPacketDocument[]): AppThunkAction<KnownAction> =>
    (dispatch) => {
      dispatch({
        type: "GET_TRUCK_WP_DOCUMENTS",
        payload: {
          isError: false,
          isLoading: false,
          result: documents
        }
      });
    },
  insertWorkPacketDataLogs:
    (
      lineHandlingNo: string,
      workPacketValues: WorkPacketValue[],
      workPacketDocuments: WorkPacketDocument[]
    ): AppThunkAction<GetTruckWPDocuments> =>
    (dispatch, getState) => {
      WorkPacketService.saveWorkPacketDataLogsAsync(
        lineHandlingNo,
        workPacketValues,
        workPacketDocuments
      );
    }
};

export const reducers: Reducer<TruckWorkPacketState> = (
  state: TruckWorkPacketState | undefined,
  incomingAction: Action
): TruckWorkPacketState => {
  if (state === undefined) {
    return defaultState;
  }

  const action = incomingAction as KnownAction;
  switch (action.type) {
    case "GET_TRUCK_WORK_PACKETS":
      return { ...state, truckWorkPackets: action.payload };
    case "GET_TRUCK_WP_VALUES":
      return { ...state, truckWorkPacketValues: action.payload };
    case "GET_TRUCK_WP_DOCUMENTS":
      return { ...state, truckWorkPacketDocuments: action.payload };
    default:
      return state;
  }
};
